import { Pipe, PipeTransform } from '@angular/core';
import { isBlank } from '@app/utils/string';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'contactName',
  standalone: false,
})
export class ContactNamePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    value: {
      firstName?: string;
      lastName?: string;
      company?: string;
      loginName?: string;
      extension?: string;
    },
    args: { type: 'short' | 'long' | 'without-comma' | 'with-extension' | 'abbreviated' } = {
      type: 'short',
    }
  ): string {
    const isSet = (str) => isBlank(str) === false;
    let returnValue = '';

    if (value != null) {
      if (isSet(value.lastName) && isSet(value.firstName)) {
        returnValue = value.lastName + ', ' + value.firstName;
      } else if (isSet(value.lastName)) {
        returnValue = value.lastName;
      } else if (isSet(value.company)) {
        returnValue = value.company;
      } else {
        returnValue = value.firstName;
      }

      if (args.type === 'short') {
        // nothing to do, is default
      } else if (args.type === 'long') {
        if (isSet(value.lastName) && isSet(value.firstName)) {
          returnValue = value.firstName + ' ' + value.lastName;
        }

        if (isSet(value.loginName)) {
          returnValue += ` (${value.loginName})`;
        }
      } else if (args.type === 'without-comma') {
        if (isSet(value.lastName) && isSet(value.firstName)) {
          returnValue = value.lastName + ' ' + value.firstName;
        }
      } else if (args.type === 'with-extension') {
        let name: string = this.transform(value);

        if (value.extension != null) {
          const extensionTranslation = this.translateService.instant('common.extension');

          returnValue = `${extensionTranslation} ${value.extension} | ${name}`;
        } else {
          returnValue = name;
        }
      } else if (args.type === 'abbreviated') {
        if (isSet(value.firstName) && isSet(value.lastName)) {
          returnValue = `${value.firstName.substring(0, 1)}. ${value.lastName}`;
        }
      }
    }

    // #48536 the lastName can be empty and if firstName is undefined this leads to undefined. hence the check.
    return returnValue ?? '';
  }
}
